import $axios from "@/service/httpServer";

export const getBasicInfo = () => $axios.post('/Web/Backend/System/getBasicInfo');
export const getManagers = () => $axios.post('/Web/Backend/System/getManagers');
export const getAccounts = () => $axios.post('/Web/Backend/System/getAccounts');
export const getLicencePrice = () => $axios.post('/Web/Backend/System/getLicencePrice');
export const buyLicences = p => $axios.post('/Web/Backend/System/buyLicences', p);
export const loadHelpMenus = p => $axios.post('/Web/Backend/System/loadHelpMenus', p);
export const listFonts = p => $axios.post('/Web/Backend/System/listFonts', p);
